import { render, staticRenderFns } from "./ModalDownloadPickup.vue?vue&type=template&id=201428d6&"
import script from "./ModalDownloadPickup.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports